<template>
  <div v-if="infoproduct" class="infoproduct-page">
    <div class="infoproduct-header-shell" :style="headerShellVars">
      <nav class="infoproduct-navbar">
        <a href="#header-section" class="infoproduct-navbar-brand">
          <v-img v-if="infoproduct.brandImage" :src="infoproduct.brandImage.src" max-width="26px" max-height="26px" contain/>
          <span v-else class="infoproduct-navbar-brand-fallback">{{ (infoproduct.title || 'M').charAt(0) }}</span>
        </a>
        <div class="infoproduct-navbar-pill" v-if="!['xs', 'sm'].includes(view) && navLinks.length">
          <a v-for="link in navLinks" :key="link.id" :href="`#${link.id}`" class="infoproduct-navbar-link">{{ link.label }}</a>
        </div>
        <div class="infoproduct-navbar-end">
          <a href="#form-section" class="infoproduct-navbar-cta" v-if="infoproduct.action" :style="`background:${infoproduct.style.btnActionColor}; color:${infoproduct.style.btnActionTextColor}`">
            <span>{{ $t(infoproduct.action.toLowerCase() + 'Now') }}</span>
            <v-icon size="15" :color="infoproduct.style.btnActionTextColor">mdi-arrow-top-right</v-icon>
          </a>
          <v-menu offset-y left :close-on-content-click="false" v-if="edit">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="white" v-bind="attrs" v-on="on" icon outlined rounded class="infoproduct-navbar-color-btn">
                <v-icon color="white">mdi-palette</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-color-picker
                  dot-size="25"
                  show-swatches
                  swatches-max-height="200"
                  mode="hexa"
                  @update:color="v => style.headerColor = v.hexa"
                />
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </nav>

      <div class="infoproduct-hero-stage" :class="{ 'infoproduct-hero-stage--stacked': ['xs', 'sm'].includes(view), 'infoproduct-hero-stage--no-image': !infoproduct.productImage }">
        <div class="infoproduct-hero-media" v-if="infoproduct.productImage" :style="`background-image: url('${infoproduct.productImage.src}')`"/>
        <div class="infoproduct-hero-scrim"/>
        <div class="infoproduct-hero-content">
          <div class="infoproduct-hero-copy" :class="{ 'infoproduct-hero-copy-center': ['xs', 'sm'].includes(view) || !infoproduct.productImage }">
            <div ref="heroSubtitle" v-if="infoproduct.subtitle" class="infoproduct-hero-eyebrow-row">
              <span class="infoproduct-hero-eyebrow" :style="`color: ${infoproduct.style.subtitleColor}; border-color: ${infoproduct.style.subtitleColor}`">
                {{ infoproduct.subtitle }}
              </span>
              <v-menu offset-y left :close-on-content-click="false" v-if="edit && infoproduct.subtitle">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small color="white" v-bind="attrs" v-on="on" icon outlined rounded class="ml-1">
                    <v-icon color="white">mdi-palette</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-color-picker
                      dot-size="25"
                      show-swatches
                      swatches-max-height="200"
                      mode="hexa"
                      @update:color="v => infoproduct.style.subtitleColor = v.hexa"
                    />
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <h1 ref="heroTitle" class="infoproduct-hero-title" :style="`color: ${infoproduct.style.titleColor}`">
              {{ infoproduct.title }}
              <v-menu offset-y left :close-on-content-click="false" v-if="edit && infoproduct.title">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small color="white" v-bind="attrs" v-on="on" icon outlined rounded class="ml-1 infoproduct-hero-title-edit-btn">
                    <v-icon color="white">mdi-palette</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-color-picker
                      dot-size="25"
                      show-swatches
                      swatches-max-height="200"
                      mode="hexa"
                      @update:color="v => infoproduct.style.titleColor = v.hexa"
                    />
                  </v-list-item>
                </v-list>
              </v-menu>
            </h1>
            <div ref="heroShortDescription" v-if="infoproduct.shortDescription" class="infoproduct-hero-short-desc-row">
              <p class="infoproduct-hero-short-desc" :style="`color: ${infoproduct.style.shortDescriptionColor}`">
                {{ infoproduct.shortDescription }}
              </p>
              <v-menu offset-y left :close-on-content-click="false" v-if="edit && infoproduct.shortDescription">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small color="white" v-bind="attrs" v-on="on" icon outlined rounded class="ml-1">
                    <v-icon color="white">mdi-palette</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-color-picker
                      dot-size="25"
                      show-swatches
                      swatches-max-height="200"
                      mode="hexa"
                      @update:color="v => infoproduct.style.shortDescriptionColor = v.hexa"
                    />
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div class="infoproduct-hero-cta-row">
              <a href="#form-section" ref="heroCta" class="infoproduct-cta-link">
                <v-btn x-large rounded :color="infoproduct.style.btnActionColor" v-if="infoproduct.action" elevation="1" :style="`color: ${infoproduct.style.btnActionTextColor};`" class="infoproduct-cta-btn">
                  {{ $t(infoproduct.action.toLowerCase() + 'Now') }}
                </v-btn>
              </a>
            </div>
          </div>
          <div class="infoproduct-hero-form-slot" ref="heroAsset">
            <div id="form-section" class="infoproduct-form-card infoproduct-form-card--hero">
              <div class="infoproduct-form-head" v-if="infoproduct.type == 'E_BOOK' || infoproduct.type == 'LINK'">
                <span class="infoproduct-form-head-icon" :style="`background: color-mix(in srgb, ${infoproduct.style.formColor} 14%, white)`">
                  <v-icon size="20" :color="infoproduct.style.formColor">{{ infoproduct.type == 'E_BOOK' ? 'mdi-book-open-page-variant' : 'mdi-link-variant' }}</v-icon>
                </span>
                <p class="infoproduct-form-lead" v-if="infoproduct.type == 'E_BOOK'">
                  {{ $t(`fillInFormForReceiveEbook`) }}
                </p>
                <p class="infoproduct-form-lead" v-else>
                  {{ $t(`fillInFormForReceiveLink`) }}
                </p>
              </div>
              <v-fade-transition hide-on-leave leave-absolute>
                <v-form v-model="form" :disabled="loadingSend || onlyView" ref="form" v-if="!isSend">
                  <div class="infoproduct-field-group">
                    <v-text-field
                      v-model="email"
                      rounded
                      :label="$t('provideYourEmail')"
                      filled
                      hide-details="auto"
                      dense
                      flat
                      :rules="[
                        v => !!v || $t('required'),
                        v => !!v && v.match(/^\S+@\S+\.\S+$/) || $t('invalid'),
                      ]"
                      :color="infoproduct.style.formColor"
                      class="infoproduct-form-field"
                      >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" class="mr-1" :color="infoproduct.style.formColor">mdi-email-outline</v-icon>
                      </template>
                    </v-text-field>
                  </div>
                  <div v-if="infoproduct.formFields && infoproduct.user && !infoproduct.user.bellowShorterProUser">
                    <div v-for="field, index in infoproduct.formFields.filter(field => !field.deleted)" :key="index" class="infoproduct-field-group">
                      <div v-if="formFields.answers.filter(f => f.field.id == field.id)[0]">
                        <v-text-field
                          v-if="field.type == 'TEXT_FIELD'"
                          v-model="formFields.answers.filter(f => f.field.id == field.id)[0].value"
                          rounded
                          :label="field.name"
                          filled
                          hide-details="auto"
                          dense
                          flat
                          :required="field.required"
                          :rules="[
                            v => ((field.required && !!v) || !field.required) || $t('required'),
                            v => (field.inputType == `NUMERIC` && v.match(/^[0-9]*$/) || field.inputType != `NUMERIC`) || $t('invalid'),
                          ]"
                          :color="infoproduct.style.formColor"
                          class="infoproduct-form-field"
                          @change="adjustField(field)"
                          />
                        <v-select
                          v-else-if="field.type == 'SELECT_FIELD'"
                          v-model="formFields.answers.filter(f => f.field.id == field.id)[0].value"
                          :items="field.options"
                          rounded
                          :label="field.name"
                          filled
                          :required="field.required"
                          hide-details="auto"
                          dense
                          flat
                          item-text="value"
                          item-value="value"
                          color="primary"
                          class="infoproduct-form-field"
                          :rules="[
                            v => field.required && !!v || $t('required')
                          ]"
                        >
                          <template v-slot:selection="{item}">
                            <span>{{ item.value }}</span>
                          </template >
                          <template v-slot:item="{item, on, attrs}">
                            <span v-bind="attrs" v-on="on">{{ item.value }}</span>
                          </template>
                        </v-select>
                      </div>
                    </div>
                  </div>
                  <p class="infoproduct-form-privacy">{{ $t('fillInYourEmailPolicyPrivacy') }}</p>
                  <v-btn rounded block :color="infoproduct.style.headerColor" :style="`color: ${infoproduct.style.titleColor}`" @click="send" :loading="loadingSend" :disabled="!form" class="infoproduct-submit-btn infoproduct-submit-btn--block">
                    {{ $t('toSend') }}
                    <v-icon size="16" :color="infoproduct.style.titleColor" class="ml-1">mdi-arrow-right</v-icon>
                  </v-btn>
                </v-form>
                <div v-else class="infoproduct-form-success">
                  <span class="infoproduct-form-success-icon" :style="`background: ${infoproduct.style.headerColor}`">
                    <v-icon size="26" color="#FFFFFF">mdi-check-bold</v-icon>
                  </span>
                  <p class="infoproduct-form-success-text">{{ $t('toSendInfoproduct') }}</p>
                </div>
              </v-fade-transition>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-container id="itens-section" class="infoproduct-section" v-if="infoproduct.itensTitle">
      <div class="infoproduct-benefits-layout" :class="{ 'infoproduct-benefits-layout--stacked': ['xs', 'sm'].includes(view) }">
        <div class="infoproduct-benefits-heading">
          <span class="infoproduct-section-eyebrow" :style="`color: ${infoproduct.style.itensTitleColor}`">{{ $t('infoproductNavBenefits') }}</span>
          <h2 class="infoproduct-section-title" :style="`color: ${infoproduct.style.itensTitleColor}`">
            {{ infoproduct.itensTitle }}
          </h2>
          <div class="infoproduct-section-cta-row infoproduct-section-cta-row--start" v-if="infoproduct.action">
            <a href="#form-section">
              <v-btn rounded :color="infoproduct.style.btnActionColor" elevation="1" :style="`color: ${infoproduct.style.btnActionTextColor};`" class="infoproduct-cta-btn">
                {{ $t(infoproduct.action.toLowerCase() + 'Now') }}
              </v-btn>
            </a>
          </div>
        </div>
        <div class="infoproduct-itens-grid" :style="itensGridStyle">
          <div v-for="(item, index) in infoproduct.itens" :key="index" class="infoproduct-item-card" :style="`background: color-mix(in srgb, ${infoproduct.style.itensColor} 7%, white)`">
            <v-icon size="22" :color="infoproduct.style.itensColor" class="infoproduct-item-icon">mdi-check-bold</v-icon>
            <p class="infoproduct-item-text" :style="`color: ${infoproduct.style.itensColor}`">
              {{ item.value }}
            </p>
          </div>
        </div>
      </div>
    </v-container>
    <div id="more-section" class="infoproduct-description-shell" v-if="infoproduct.description">
      <v-container>
        <div class="infoproduct-description-copy">
          <div class="infoproduct-description-box" :style="`background: ${infoproduct.style.descriptionBackgroundColor}`">
            <span class="infoproduct-section-eyebrow" :style="`color: ${infoproduct.style.descriptionColor}`">
              {{ $t('infoproductNavAbout') }}
            </span>
            <div class="infoproduct-description-col" :style="`color: ${infoproduct.style.descriptionColor}`">
              <p v-for="(text, index) in infoproduct.description.split(/\r?\n|\r|\n/g)" :key="index" class="infoproduct-description-p">
                <b v-if="index > 0 && (index + 1) % 2 == 0">{{ text }}</b>
                <span v-else>{{ text }}</span>
              </p>
            </div>
            <div class="infoproduct-section-cta-row" v-if="infoproduct.action">
              <a href="#form-section">
                <v-btn rounded :color="infoproduct.style.btnActionColor" elevation="1" :style="`color: ${infoproduct.style.btnActionTextColor};`" class="infoproduct-cta-btn">
                  {{ $t(infoproduct.action.toLowerCase() + 'Now') }}
                </v-btn>
              </a>
            </div>
            <div class="infoproduct-description-image-row" v-if="infoproduct.productImage">
              <img :src="infoproduct.productImage.src" alt="infoproduct" class="infoproduct-description-image"/>
            </div>
          </div>
        </div>
      </v-container>
    </div>
    <v-container class="infoproduct-section infoproduct-form-repeat-section">
      <div class="infoproduct-form-card">
        <div class="infoproduct-form-head" v-if="infoproduct.type == 'E_BOOK' || infoproduct.type == 'LINK'">
          <span class="infoproduct-form-head-icon" :style="`background: color-mix(in srgb, ${infoproduct.style.formColor} 14%, white)`">
            <v-icon size="20" :color="infoproduct.style.formColor">{{ infoproduct.type == 'E_BOOK' ? 'mdi-book-open-page-variant' : 'mdi-link-variant' }}</v-icon>
          </span>
          <p class="infoproduct-form-lead" v-if="infoproduct.type == 'E_BOOK'">
            {{ $t(`fillInFormForReceiveEbook`) }}
          </p>
          <p class="infoproduct-form-lead" v-else>
            {{ $t(`fillInFormForReceiveLink`) }}
          </p>
        </div>
        <v-fade-transition hide-on-leave leave-absolute>
          <v-form v-model="form" :disabled="loadingSend || onlyView" v-if="!isSend">
            <div class="infoproduct-field-group">
              <v-text-field
                v-model="email"
                rounded
                :label="$t('provideYourEmail')"
                filled
                hide-details="auto"
                dense
                flat
                :rules="[
                  v => !!v || $t('required'),
                  v => !!v && v.match(/^\S+@\S+\.\S+$/) || $t('invalid'),
                ]"
                :color="infoproduct.style.formColor"
                class="infoproduct-form-field"
                >
                <template v-slot:prepend-inner>
                  <v-icon size="18" class="mr-1" :color="infoproduct.style.formColor">mdi-email-outline</v-icon>
                </template>
              </v-text-field>
            </div>
            <div v-if="infoproduct.formFields && infoproduct.user && !infoproduct.user.bellowShorterProUser">
              <div v-for="field, index in infoproduct.formFields.filter(field => !field.deleted)" :key="index" class="infoproduct-field-group">
                <div v-if="formFields.answers.filter(f => f.field.id == field.id)[0]">
                  <v-text-field
                    v-if="field.type == 'TEXT_FIELD'"
                    v-model="formFields.answers.filter(f => f.field.id == field.id)[0].value"
                    rounded
                    :label="field.name"
                    filled
                    hide-details="auto"
                    dense
                    flat
                    :required="field.required"
                    :rules="[
                      v => ((field.required && !!v) || !field.required) || $t('required'),
                      v => (field.inputType == `NUMERIC` && v.match(/^[0-9]*$/) || field.inputType != `NUMERIC`) || $t('invalid'),
                    ]"
                    :color="infoproduct.style.formColor"
                    class="infoproduct-form-field"
                    @change="adjustField(field)"
                    />
                  <v-select
                    v-else-if="field.type == 'SELECT_FIELD'"
                    v-model="formFields.answers.filter(f => f.field.id == field.id)[0].value"
                    :items="field.options"
                    rounded
                    :label="field.name"
                    filled
                    :required="field.required"
                    hide-details="auto"
                    dense
                    flat
                    item-text="value"
                    item-value="value"
                    color="primary"
                    class="infoproduct-form-field"
                    :rules="[
                      v => field.required && !!v || $t('required')
                    ]"
                  >
                    <template v-slot:selection="{item}">
                      <span>{{ item.value }}</span>
                    </template >
                    <template v-slot:item="{item, on, attrs}">
                      <span v-bind="attrs" v-on="on">{{ item.value }}</span>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
            <p class="infoproduct-form-privacy">{{ $t('fillInYourEmailPolicyPrivacy') }}</p>
            <v-btn rounded block :color="infoproduct.style.headerColor" :style="`color: ${infoproduct.style.titleColor}`" @click="send" :loading="loadingSend" :disabled="!form" class="infoproduct-submit-btn infoproduct-submit-btn--block">
              {{ $t('toSend') }}
              <v-icon size="16" :color="infoproduct.style.titleColor" class="ml-1">mdi-arrow-right</v-icon>
            </v-btn>
          </v-form>
          <div v-else class="infoproduct-form-success">
            <span class="infoproduct-form-success-icon" :style="`background: ${infoproduct.style.headerColor}`">
              <v-icon size="26" color="#FFFFFF">mdi-check-bold</v-icon>
            </span>
            <p class="infoproduct-form-success-text">{{ $t('toSendInfoproduct') }}</p>
          </div>
        </v-fade-transition>
      </div>
    </v-container>
    <v-footer id="footer-section" v-if="infoproduct.user && !infoproduct.user.bellowShorterProUser && infoproduct.footer" :color="infoproduct.style.footerBackgroundColor" dark class="infoproduct-footer">
      <div class="infoproduct-footer-inner">
        <div class="infoproduct-footer-content">
          <img :src="infoproduct.footer.brandImage.src" width="130" class="infoproduct-footer-brand" v-if="infoproduct.footer.brandImage" alt="infoproduct"/>
          <div class="infoproduct-footer-text" :style="`color: ${infoproduct.style.footerTextColor}`" v-if="infoproduct.footer.text">
            <p v-for="(text, index) in infoproduct.footer.text.split(/\r?\n|\r|\n/g)" :key="index">
              <b v-if="index % 2 == 0">{{ text }}</b>
              <span v-else>{{ text }}</span>
            </p>
          </div>
        </div>
        <div class="infoproduct-footer-divider" :style="`color: ${infoproduct.style.footerTextColor}`" v-if="infoproduct.footer.links && (infoproduct.footer.text || infoproduct.footer.brandImage)"/>
        <div class="infoproduct-footer-links" v-if="infoproduct.footer.links">
          <template v-for="(link, index) in infoproduct.footer.links.filter(link => !link.deleted)">
            <v-icon :key="`dot-${index}`" size="6" class="infoproduct-footer-link-dot" :color="infoproduct.style.footerTextColor" v-if="index > 0">mdi-circle</v-icon>
            <a :key="index" :href="link.href" class="link infoproduct-footer-link" :style="`color: ${infoproduct.style.footerTextColor}`">
              {{ link.name }}
            </a>
          </template>
        </div>
      </div>
    </v-footer>
    <v-footer id="footer-section" v-else dark class="infoproduct-footer">
      <v-container>
        <v-card elevation="0" color="transparent">
          <v-card-actions>
            <v-spacer/>
            {{ $t('infoproductCreateBy') }}
            <v-spacer/>
          </v-card-actions>
          <v-card-actions class="pt-1 pb-1 pl-1 pr-1">
            <v-spacer/>
            <a href="/" class="link">
              <img src="/images/logo/logo-04.png" width="150" class="mr-2" alt="migly"/>
            </a>
            <v-spacer/>
          </v-card-actions>
          <v-card-actions class="white--text">
            <v-spacer/>
            <small><p>migly.in é um produto <a class="link infoproduct-footer-link" target="_blank" href="http://exatamente-solucoes.com"> exatamente soluções.</a></p></small>
            <v-spacer/>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-footer>
  </div>
</template>
<script>
import { apiV1InfoproductFormAnswer } from '../../../service/resources/api-v1-infoproduct-form-answer'
import { gsap } from 'gsap'


export default {
    name: 'InfoproductView',
    props: ['infoproduct', 'screenData', 'edit', 'view', 'onlyView'],
    components: {
    },
    data: () => ({
      email: null,
      formFields: {answers: [], email: ''},
      form: false,
      loadingSend: false,
      isSend: false
    }),
    watch: {
      'infoproduct.formFields': function() {
        this.defineFormFields()
        this.$forceUpdate()
      },
    },
    mounted: function() {
      this.defineFormFields()
      this.playHeroEntrance()
    },
    computed: {
      // CSS custom properties feeding the gradient blends below - keeps the
      // gradient math in CSS while the actual colors stay fully user-driven
      // (infoproduct.style.*), consistent with how every other color in this
      // page is already wired.
      headerShellVars: function() {
        return { '--header-color': this.infoproduct.style.headerColor }
      },
      // Only link to sections that actually exist/have content, so an
      // infoproduct without topics or a description doesn't leave a dead
      // link in the nav pill.
      navLinks: function() {
        const links = []
        if(this.infoproduct.itensTitle && this.infoproduct.itens && this.infoproduct.itens.filter(item => !item.deleted).length)
          links.push({ id: 'itens-section', label: this.$t('infoproductNavBenefits') })
        if(this.infoproduct.description)
          links.push({ id: 'more-section', label: this.$t('infoproductNavAbout') })
        links.push({ id: 'form-section', label: this.$t('infoproductNavContact') })
        return links
      },
      // Auto-fit CSS grid instead of a fixed 12-col split, so the benefits
      // grid reflows cleanly whatever number of topics/items the user added
      // (3, 4, 6...) instead of leaving an orphaned card on its own row.
      // Tracks have a capped max width (not 1fr) so a row with fewer items
      // than fit doesn't stretch to fill - it stays its natural size and
      // centers instead, via justify-content on the grid itself.
      itensGridStyle: function() {
        if(this.view === 'xs')
          return { gridTemplateColumns: '1fr' }
        if(this.view === 'sm')
          return { gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 220px))', justifyContent: 'center' }
        return { gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 200px))', justifyContent: 'center' }
      }
    },
    methods: {
      // Header hero entrance - eyebrow, title, short description, CTA button
      // and the floating lead-capture card. Runs once on mount, not
      // scroll-triggered; below-the-fold sections (itens, description,
      // footer) stay static, matching the bio page's own precedent
      // (BiographySmartphoneView.vue's playHeroEntrance).
      playHeroEntrance: function() {
        const resolve = (ref) => ref ? (ref.$el || ref) : null
        const asset = resolve(this.$refs.heroAsset)
        const title = resolve(this.$refs.heroTitle)
        const subtitle = resolve(this.$refs.heroSubtitle)
        const shortDescription = resolve(this.$refs.heroShortDescription)
        const cta = resolve(this.$refs.heroCta)
        const targets = [asset, title, subtitle, shortDescription, cta].filter(Boolean)
        if (!targets.length) return
        const reveal = () => gsap.set(targets, { opacity: 1, y: 0, scale: 1, clearProps: 'transform' })
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          reveal()
          return
        }
        // Safety net: the CTA button and lead-capture card start at
        // opacity:0 below and only reach opacity:1 once this timeline
        // finishes. If it never ticks to completion (a throttled/
        // backgrounded tab, or any error thrown mid-timeline) those
        // elements - the page's actual conversion path - would stay
        // invisible forever while still taking up their layout space.
        // This timer guarantees they surface regardless.
        const safetyTimer = setTimeout(reveal, 2000)
        try {
          if (asset) gsap.set(asset, { opacity: 0, scale: 0.94, y: 18 })
          gsap.set([subtitle, title, shortDescription, cta].filter(Boolean), { opacity: 0, y: 14 })
          const tl = gsap.timeline({ delay: 0.1, onComplete: () => clearTimeout(safetyTimer) })
          if (subtitle) tl.to(subtitle, { opacity: 1, y: 0, duration: 0.4, ease: 'power2.out', clearProps: 'transform' })
          if (title) tl.to(title, { opacity: 1, y: 0, duration: 0.4, ease: 'power2.out', clearProps: 'transform' }, '-=0.25')
          if (shortDescription) tl.to(shortDescription, { opacity: 1, y: 0, duration: 0.4, ease: 'power2.out', clearProps: 'transform' }, '-=0.25')
          if (cta) tl.to(cta, { opacity: 1, y: 0, duration: 0.4, ease: 'power2.out', clearProps: 'transform' }, '-=0.25')
          if (asset) tl.to(asset, { opacity: 1, y: 0, scale: 1, duration: 0.55, ease: 'back.out(1.6)', clearProps: 'transform' }, '-=0.3')
        } catch (e) {
          clearTimeout(safetyTimer)
          reveal()
        }
      },
      defineFormFields: function() {
        this.formFields = {answers: [], email: ''}
        if(this.infoproduct && this.infoproduct.formFields) {
          this.infoproduct.formFields
          .filter(element => !element.deleted)
          .forEach((element) => {
            this.formFields.answers.push({field: element, value: ''})
          })
          console.log(this.formFields)
        }
      },
      adjustField: function(field) {
        console.log(field)
      },
      send: function(){
        this.formFields.email = this.email
        this.formFields.infoproduct = {id: this.infoproduct.id}
        console.log(this.formFields)
        this.loadingSend = true
        apiV1InfoproductFormAnswer.save(this.formFields).then(result => {
          console.log(result)
          this.$commons.updateSnackbar({show: true, color: 'success', text: this.$t('saved')})
          this.isSend = true
        }).finally(() => {
          this.loadingSend = false
        })
      }
    },
  }
</script>
<style scoped>
/* Tactile hover/press feedback on the primary CTA and form-submit actions,
   matching the bio page's .bio-share-btn convention: lift+shadow on hover
   (guarded to real pointer devices), scale-down on press, and a
   prefers-reduced-motion override that drops the transition entirely. */
.infoproduct-cta-link {
  text-decoration: none;
  display: inline-block;
}
.infoproduct-cta-btn,
.infoproduct-submit-btn {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
@media (hover: hover) {
  .infoproduct-cta-btn:hover,
  .infoproduct-submit-btn:hover:not(.v-btn--disabled) {
    transform: translateY(-2px);
    box-shadow: 0 10px 22px rgba(16, 24, 39, 0.24);
  }
}
.infoproduct-cta-btn:active,
.infoproduct-submit-btn:active:not(.v-btn--disabled) {
  transform: scale(0.96);
}
@media (prefers-reduced-motion: reduce) {
  .infoproduct-cta-btn,
  .infoproduct-submit-btn {
    transition: none;
  }
  .infoproduct-cta-btn:hover,
  .infoproduct-cta-btn:active,
  .infoproduct-submit-btn:hover,
  .infoproduct-submit-btn:active {
    transform: none;
  }
}

/* ============================================================
   Page canvas - reuses Migly's own established neutral token
   (#F7F5EF, already used for the panel's nav-drawer background)
   rather than inventing an unrelated off-white, so the public
   page stays in the same visual family as the rest of the product.
   Exposed as a custom property so every section's gradient blend
   below can fade into it without repeating the literal hex value.
   ============================================================ */
.infoproduct-page {
  background: #F7F5EF;
  --page-bg: #F7F5EF;
}

/* ============================================================
   Shared section rhythm + typography scale.
   ============================================================ */
.infoproduct-section {
  padding-top: clamp(2.5rem, 6vw, 5rem);
  padding-bottom: clamp(2.5rem, 6vw, 5rem);
}
.infoproduct-section-eyebrow {
  display: inline-block;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  opacity: 0.75;
  margin-bottom: 0.6rem;
}
.infoproduct-section-title {
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: clamp(1.5rem, 3.4vw, 2.15rem);
  line-height: 1.2;
  margin: 0;
}
.infoproduct-section-title-center {
  text-align: center;
  max-width: 42ch;
  margin-left: auto;
  margin-right: auto;
}
.infoproduct-section-cta-row {
  display: flex;
  justify-content: center;
  margin-top: 2.5rem;
}
.infoproduct-section-cta-row--start {
  justify-content: flex-start;
}

/* ============================================================
   Header shell - navbar + hero. No hard right-angle corners: the
   whole shell rounds off into the page background through a
   gradient fade instead of a flat color cut, and the header color
   itself renders as a soft diagonal gradient rather than one flat
   fill ("degradê que mescle as cores").
   ============================================================ */
.infoproduct-header-shell {
  position: relative;
  overflow: hidden;
  border-radius: clamp(1.5rem, 4vw, 3rem);
  background: var(--header-color);
}
.infoproduct-header-shell::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: clamp(3rem, 10vw, 6.5rem);
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, var(--page-bg) 100%);
  pointer-events: none;
}
/* ============================================================
   Navbar
   ============================================================ */
.infoproduct-navbar {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem clamp(1.25rem, 4vw, 3rem) 0.25rem;
}
.infoproduct-navbar-brand {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.94);
  overflow: hidden;
  flex-shrink: 0;
}
.infoproduct-navbar-brand-fallback {
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 1.05rem;
  color: #101827;
}
.infoproduct-navbar-pill {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 999px;
  padding: 0.3rem;
  backdrop-filter: blur(6px);
}
.infoproduct-navbar-link {
  color: rgba(255, 255, 255, 0.88);
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 0.8rem;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  transition: background 0.2s ease, color 0.2s ease;
  white-space: nowrap;
}
@media (hover: hover) {
  .infoproduct-navbar-link:hover {
    background: rgba(255, 255, 255, 0.94);
    color: #101827;
  }
}
.infoproduct-navbar-end {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}
.infoproduct-navbar-cta {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.8rem;
  padding: 0.6rem 1.05rem;
  border-radius: 999px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  white-space: nowrap;
}
@media (hover: hover) {
  .infoproduct-navbar-cta:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.24);
  }
}

/* ============================================================
   Hero stage
   ============================================================ */
.infoproduct-hero-stage {
  position: relative;
  z-index: 1;
  min-height: clamp(20rem, 44vw, 32rem);
  display: flex;
  padding: clamp(1.5rem, 4vw, 3rem) clamp(1.25rem, 4vw, 3rem) clamp(3.5rem, 8vw, 5.5rem);
}
.infoproduct-hero-media {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
}
.infoproduct-hero-scrim {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, var(--header-color) 0%, color-mix(in srgb, var(--header-color) 45%, transparent) 35%, rgba(0, 0, 0, 0) 70%);
}
.infoproduct-hero-stage--no-image .infoproduct-hero-scrim {
  background: none;
}
.infoproduct-hero-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: clamp(1.5rem, 4vw, 3rem);
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
}
.infoproduct-hero-stage--stacked .infoproduct-hero-content {
  flex-direction: column;
  align-items: stretch;
}
.infoproduct-hero-copy {
  position: relative;
  flex: 1;
  min-width: 0;
}
.infoproduct-hero-copy-center {
  text-align: center;
  max-width: 62ch;
  margin: 0 auto;
}
.infoproduct-hero-eyebrow-row {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
.infoproduct-hero-copy-center .infoproduct-hero-eyebrow-row {
  justify-content: center;
}
.infoproduct-hero-eyebrow {
  display: inline-flex;
  align-items: center;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  border: 1.5px solid currentColor;
  border-radius: 999px;
  padding: 0.4rem 1rem;
}
.infoproduct-hero-title {
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: clamp(1.85rem, 4.2vw, 3.1rem);
  line-height: 1.12;
  letter-spacing: -0.01em;
  margin: 0 0 1.1rem;
}
.infoproduct-hero-title-edit-btn {
  vertical-align: middle;
}
.infoproduct-hero-short-desc-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.75rem;
}
.infoproduct-hero-copy-center .infoproduct-hero-short-desc-row {
  justify-content: center;
}
.infoproduct-hero-short-desc {
  font-size: clamp(1rem, 1.4vw, 1.15rem);
  line-height: 1.6;
  max-width: 48ch;
  margin: 0;
  opacity: 0.92;
}
.infoproduct-hero-cta-row {
  display: flex;
}
.infoproduct-hero-copy-center .infoproduct-hero-cta-row {
  justify-content: center;
}

/* Stacked (smartphone) hero: the product photo becomes a contained,
   rounded banner sitting above the copy instead of a full-bleed
   background - overlaying text on a narrow image rarely reads well,
   so text drops below the image here instead. */
.infoproduct-hero-stage--stacked {
  flex-direction: column;
  min-height: 0;
  padding: clamp(1.5rem, 6vw, 2.25rem) clamp(1rem, 5vw, 1.5rem) clamp(2.5rem, 8vw, 3rem);
}
.infoproduct-hero-stage--stacked .infoproduct-hero-media {
  flex-shrink: 0;
  position: relative;
  inset: auto;
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.18);
}
.infoproduct-hero-stage--stacked .infoproduct-hero-scrim {
  display: none;
}

/* ============================================================
   Floating lead-capture form card (right side of the hero on
   desktop, per the reference layout; a normal stacked block below
   the copy on smartphone).
   ============================================================ */
.infoproduct-hero-form-slot {
  flex-shrink: 0;
  width: min(380px, 100%);
}
/* Same lead-capture form repeated as its own section right before the
   footer, so a visitor who scrolls past everything without converting
   in the hero gets a second, final chance. */
.infoproduct-form-repeat-section {
  display: flex;
  justify-content: center;
}
.infoproduct-form-repeat-section .infoproduct-form-card {
  width: min(420px, 100%);
}
.infoproduct-form-card {
  background: #FFFFFF;
  border-radius: 1.5rem;
  box-shadow: 0 14px 34px rgba(16, 24, 39, 0.08);
  padding: clamp(1.5rem, 4vw, 2rem) clamp(1.25rem, 3vw, 1.75rem) clamp(1.75rem, 4vw, 2rem);
}
.infoproduct-form-card--hero {
  box-shadow: 0 24px 48px rgba(16, 24, 39, 0.22);
}
.infoproduct-form-head {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}
.infoproduct-form-head-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
}
.infoproduct-form-lead {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.95rem;
  line-height: 1.35;
  color: #101827;
  margin: 0;
}

/* Same soft filled treatment as the wizard's own inputs
   (InfoproductEditForm.vue's .ip-text-field), so the public
   lead-capture form reads as one modern system with the rest
   of the product instead of Vuetify's default outlined chrome. */
.infoproduct-field-group {
  margin-bottom: 0.85rem;
}
.infoproduct-form-field ::v-deep .v-input__slot {
  background: #F7F5EF !important;
  box-shadow: none !important;
}
.infoproduct-form-privacy {
  font-size: 0.72rem;
  line-height: 1.5;
  color: #7E8EA6;
  text-align: center;
  margin: 0.25rem 0 1.1rem;
}
.infoproduct-submit-btn--block {
  width: 100%;
}

/* ============================================================
   Success state - a tactile pop-in instead of a static swap,
   matching Rule 5's "successful states should not be static".
   ============================================================ */
.infoproduct-form-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1.5rem 0.5rem;
}
.infoproduct-form-success-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  margin-bottom: 1rem;
  animation: infoproduct-success-pop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
}
@keyframes infoproduct-success-pop {
  0% { transform: scale(0.4); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}
@media (prefers-reduced-motion: reduce) {
  .infoproduct-form-success-icon {
    animation: none;
  }
}
.infoproduct-form-success-text {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: #101827;
  margin: 0;
}

/* ============================================================
   Benefits / itens - title+CTA in a left column, the benefit
   columns in a right block (split layout, not a centered header
   over a full-width grid). Cards are flat tinted panels (no
   shadow), auto-fit but capped to a max track width so a row
   with fewer items than fit centers as a group instead of
   stretching to fill the row.
   ============================================================ */
#itens-section {
  position: relative;
}
.infoproduct-benefits-layout {
  display: flex;
  align-items: flex-start;
  gap: clamp(2rem, 5vw, 4rem);
}
.infoproduct-benefits-layout--stacked {
  flex-direction: column;
  align-items: stretch;
  text-align: center;
}
.infoproduct-benefits-heading {
  flex: 0 0 clamp(220px, 28vw, 340px);
}
.infoproduct-benefits-layout--stacked .infoproduct-benefits-heading {
  flex-basis: auto;
}
.infoproduct-benefits-layout--stacked .infoproduct-section-cta-row--start {
  justify-content: center;
}
.infoproduct-itens-grid {
  display: grid;
  gap: 1.25rem;
  flex: 1;
  min-width: 0;
}
.infoproduct-item-card {
  position: relative;
  border-radius: 1rem;
  padding: 1.5rem 1.25rem;
  text-align: left;
  transition: filter 0.2s ease;
}
@media (hover: hover) {
  .infoproduct-item-card:hover {
    filter: brightness(0.97);
  }
}
.infoproduct-item-icon {
  display: block;
  margin-bottom: 0.9rem;
}
.infoproduct-item-text {
  font-size: 0.92rem;
  font-weight: 600;
  line-height: 1.45;
  margin: 0;
}

/* ============================================================
   Description section - text sits in a solid box using the
   client's chosen descriptionBackgroundColor, for readability.
   No background image (tried and removed - didn't read well).
   ============================================================ */
.infoproduct-description-shell {
  padding: clamp(1.5rem, 4vw, 2.5rem) 0;
}
.infoproduct-description-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.25rem;
  width: 100%;
}
.infoproduct-description-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.25rem;
  width: 100%;
  border-radius: 1.25rem;
  padding: clamp(1.5rem, 4vw, 2.5rem);
}
.infoproduct-description-box > .infoproduct-section-cta-row {
  width: 100%;
}
.infoproduct-description-image-row {
  display: flex;
  justify-content: center;
  width: 100%;
}
.infoproduct-description-image {
  max-width: min(100%, 28rem);
  max-height: 22rem;
  width: auto;
  object-fit: contain;
  border-radius: 1rem;
}
.infoproduct-description-col {
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: clamp(1.05rem, 1.5vw, 1.3rem);
  line-height: 1.45;
  letter-spacing: -0.005em;
}
.infoproduct-description-p {
  margin: 0 0 0.5rem;
}

/* ============================================================
   Footer - fully rounded floating card (card-style treatment,
   matching the reference), pulled in from the side/bottom edges
   instead of a flat full-bleed bar.
   ============================================================ */
.infoproduct-footer {
  position: relative;
  overflow: hidden;
  width: 100%;
  border-radius: clamp(1.5rem, 4vw, 2.5rem);
  margin: 0 0 clamp(1.5rem, 4vw, 2.5rem);
  padding: 0;
}
/* ============================================================
   Footer content - brand, text and links left-aligned, no
   product image (removed per the client's request).
   ============================================================ */
.infoproduct-footer-inner {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: clamp(2.5rem, 6vw, 3.5rem) clamp(1.5rem, 5vw, 3.5rem);
}
.infoproduct-footer-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
  text-align: left;
}
.infoproduct-footer-brand {
  display: block;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  object-fit: cover;
  background: rgba(255, 255, 255, 0.94);
}
.infoproduct-footer-text {
  text-align: left;
}
.infoproduct-footer-text p {
  margin: 0 0 0.35rem;
}
.infoproduct-footer-divider {
  width: 100%;
  height: 1px;
  background: currentColor;
  opacity: 0.25;
}
.infoproduct-footer-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
}
.infoproduct-footer-link-dot {
  opacity: 0.5;
  font-size: 0.7rem;
}
.infoproduct-footer-link {
  transition: opacity 0.2s ease;
}
@media (hover: hover) {
  .infoproduct-footer-link:hover {
    opacity: 0.75;
  }
}
</style>
